import * as actionTypes from '../../actions/action-types.js'

const initialState = {
    customer: {
        lastFetch: 0,
        loading: false,
    },
}

const payments = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STORE_INIT:
            return {
                ...initialState,
            }
        case actionTypes.FD_PAYMENTS_CUSTOMER_REQUEST_SUCCESS:
            return {
                ...state,
                customer: {
                    ...state.customer,
                    loading: false,
                    lastFetch: Date.now(),
                    data: action.data,
                },
            }
        case actionTypes.FD_PAYMENTS_CUSTOMER_REQUEST:
            return {
                ...state,
                customer: {
                    ...state.customer,
                    loading: true,
                },
            }
        case actionTypes.FD_PAYMENTS_CUSTOMER_REQUEST_FAILURE:
            return {
                ...state,
                customer: {
                    ...state.customer,
                    loading: false,
                    error: action.error,
                    lastError: Date.now(),
                },
            }
        case actionTypes.FD_PAYMENTS_CUSTOMER_REQUEST_CACHE:
            return state
        default: {
            return state
        }
    }
}

export default payments
